import { queryOptions } from '@tanstack/react-query';
import { getAIServiceToken } from '.';

export const aiServiceKeys = {
  all: ['ai-services'] as const,
  token: (id: string) => [...aiServiceKeys.all, 'token', id] as const,
};

export const getTokenOption = (params: { workspace_id: string }) => {
  return queryOptions({
    queryKey: [aiServiceKeys.token, params.workspace_id],
    queryFn: () => getAIServiceToken(params),
    staleTime: 1000 * 60 * 5,
  });
};
